import { createFeatureSelector } from '@ngrx/store';

import {
  ENTITY_FEATURE_KEY,
  entityAdapter,
  entityState,
  State,
} from './reducer';

export const getEntityState = createFeatureSelector<State>(ENTITY_FEATURE_KEY);

const { selectAll, selectEntities } = entityAdapter.getSelectors();

export const sharedSelectors = entityState.getSelectors(
  selectAll,
  selectEntities,
  getEntityState
);
